import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FormTitle from '@src/mobile/phtvHostHK2024/layout/Component/FormTitle';
import FormWaring from '@src/mobile/phtvHostHK2024/layout/Component/FormWaring';
import UploadVideo from './UploadVideo';
import UploadPic from './UploadPic';
import { zhanden } from '@src/utils/zhanden'; 

const Media = ({ formData, setFormDataHandle, warningTextList, updateId, updateSuccess, languages }) => {
    
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.media}>
            {/* 形象照片 */}
            <FormTitle name="img" title={zhanden[languages].photo.title} warningText={warningTextList['img']} isRequired={true} />
            <div className={styles.picInfo}>{zhanden[languages].photo.placeholder}</div>
            <div className={styles.picList}>
                <UploadPic
                    name="img1"
                    formData={formData}
                    changeInputHandle={changeInputHandle}
                    updateId={updateId}
                    updateSuccess={updateSuccess}
                    languages={languages}
                />
                <UploadPic
                    name="img2"
                    formData={formData}
                    changeInputHandle={changeInputHandle}
                    updateId={updateId}
                    updateSuccess={updateSuccess}
                    languages={languages}
                />
            </div>
            <FormWaring warningText={warningTextList['img']} />
            {/* 自我介绍视频 */}
            <FormTitle name="video_self" title={zhanden[languages].videoSelf.title} warningText={warningTextList['video_self']} isRequired={true} />
            <div className={styles.picInfo}>{zhanden[languages].videoSelf.placeholder}</div>
            <UploadVideo name="video_self" formData={formData} changeInputHandle={changeInputHandle} languages={languages} />
            <FormWaring warningText={warningTextList['video_self']} />
            {/* 视频作品 */}
            <FormTitle name="video_production" title={zhanden[languages].videoProduct.title} warningText={warningTextList['video_production']} isRequired={true} />
            <div className={styles.picInfo}>{zhanden[languages].videoProduct.placeholder}</div>
            <UploadVideo name="video_production" formData={formData} changeInputHandle={changeInputHandle} languages={languages} />
            <FormWaring warningText={warningTextList['video_production']} />
        </div>
    );
};

Media.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateId: PropTypes.string,
    updateSuccess: PropTypes.bool,
    languages: PropTypes.string
};

export default errorBoundary(Media);
